import { useAtom } from 'jotai';

import columnVisibilityAtom from '~atoms/columnVisibilityAtom';

const useColumnVisibility = () => {
	const [columnVisibilities, setColumnVisibilities] = useAtom(columnVisibilityAtom);

	const isShown = (columnName: string, defaultValue: boolean): boolean => {
		return columnVisibilities[columnName] ?? defaultValue;
	};

	const update = (columnName: string, newValue: boolean) => {
		setColumnVisibilities((prev) => ({
			...prev,
			[columnName]: newValue,
		}));
	};

	return {
		isShown,
		update,
	};
};

export default useColumnVisibility;
